// Main Menu
import { getElement, ifSelectorExist, off } from "./utils";

export default function headerInit() {
  const header = getElement("header");
  const body = getElement("body");
  let isSticked = false;
  if (ifSelectorExist(header) && ifSelectorExist(header)) {
    document.addEventListener("scroll", (e) => {
      if (!isSticked && window.scrollY >= 46) {
        header.classList.add("sticked");
        body.classList.add("menu-sticked");

        isSticked = true;
      }

      if (isSticked && window.scrollY <= 50) {
        header.classList.remove("sticked");
        body.classList.remove("menu-sticked");
        isSticked = false;
      }
    });
  }
}
